import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/main.css";
import "./components/course-details/ManageContent.css";
import "./components/course-details/courseMedia.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/css/ChatMod.scss";
import "./assets/css/upload.css";
import "./assets/css/Profile.scss";
import "../src/pages/auth/newauth/NewLogin.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://d42c127e47db172de7df2292fdeef3ad@o4507187943112704.ingest.us.sentry.io/4508462607761408",
  environment: process.env.REACT_APP_ENV,
  sendDefaultPii: true,
  _experiments: { enableLogs: true },
  integrations: [Sentry.httpClientIntegration()]
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode >
    <App />
 </React.StrictMode>
);
reportWebVitals();
